import {
  CancelV2ATransferResultError,
  CancelV2ATransferResultSuccess,
  Mutation,
} from '@varo/graphql-schema-types';
import CancelV2ATransfer from 'services/graphql/mutations/MoveMoney/CancleV2ATransfer';
import { useMutation } from 'urql';

export const useCancelTransaction = () => {
  const [mutationResult, executeMutation] =
    useMutation<Mutation>(CancelV2ATransfer);

  const {
    fetching: mutationFetching,
    data: mutationData,
    error: mutationError,
  } = mutationResult;

  const cancelTransaction = async (transferId: string) => {
    await executeMutation({ transferId });
  };

  const cancelResult = mutationData?.cancelV2ATransfer;

  const transactionCancelled =
    (cancelResult as CancelV2ATransferResultSuccess)?.success || false;

  const cancelTransactionError = (cancelResult as CancelV2ATransferResultError)
    ?.code
    ? cancelResult
    : mutationError;

  return {
    cancelTransaction,
    cancelling: mutationFetching,
    transactionCancelled,
    cancelTransactionError,
  };
};
